import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { Button, Col, Container, Row, Card } from "react-bootstrap";
import logo from "assets/imgs/Logo-Principal-Brancopng.png";
import "../../RedefinirSenha/styles.scss";
import { useNavigate } from "react-router-dom";

const PasswordChanged = () => {
  const navigate = useNavigate();

  return (
    <div className="content-wrapper">
      <Container>
        <Row className="vh-150 d-flex justify-content-center align-items-center content-redefinir-senha">
          <Col md={12} lg={10} xs={12}>
            <Card className="shadow">
              <Row className="g-0 h-150">
                <Col md={4} className="column-img-redefinir-senha ">
                  <img
                    src={logo}
                    alt="Imagem de registro"
                    className="img-fluid card-img"
                  />
                </Col>
                <Col md={8}>
                  <Card.Body className="h-100 d-flex flex-column m-3">
                    <div className="mb-3 mt-4">
                      <h3 className="fw-bold  mb-2">
                        Senha alterada com sucesso!
                      </h3>
                      <p className="mb-5">
                        Agora você pode utilizar suas novas informações de
                        segurança para acessar sua conta.
                      </p>

                      <div className="d-flex justify-content-between gap-3">
                        <Button
                          variant="primary"
                          type="button"
                          onClick={() => navigate("/login")}
                        >
                          <FontAwesomeIcon icon={faArrowLeft} size="1x" />{" "}
                          Voltar
                        </Button>
                      </div>
                    </div>
                  </Card.Body>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default PasswordChanged;
